module.exports = __webpack_public_path__ + "assets/ko-fi.00ca4d72.svg";